// extracted by mini-css-extract-plugin
export default {"triagePillButtons":"Triage_triagePillButtons__pYx2o"};